module.exports = __webpack_public_path__ + "static/media/sweet_7_tablet.28b74c58.png";